import { Box, Container, Grid } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Section from "./Section";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import * as React from "react";
import { ReactComponent as LogoSvg } from "../assets/logo.svg";

export default function FinalQuote() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Section id="finalQuote">
      <Container sx={{ minHeight: "50vh", overflow: "hidden", display: 'flex', alignItems: 'center' }}>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{ height: "100%", py: 6, px: 2 }}
        >
          <Box sx={{ width: "100%" }}>
            <Typography
              variant="h3"
              sx={{
                color: "#f5c33d",
                textAlign: "center",
                fontSize: { xs: "1.75rem", sm: "2rem" },
                fontWeight: 300,
              }}
            >
              <b>Час - це ключ.</b><br/>Ваша інвестиція була мудрою.<br/>Попереду солодка мить спокою у
              бездоганному домі, де кожна деталь налаштована на гармонію.<br/>Прекрасний момент, щоб насолодитись
              улюбленою кавою та смакувати тишу, яка тепер належить тільки Вам.
            </Typography>
          </Box>
        </Grid>
      </Container>
    </Section>
  );
}
